/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Fleet_PinnedInputs */

const vi_station_fleet_pinned = /** @type {(inputs: Station_Fleet_PinnedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã ghim`)
};

/**

* @param {Station_Fleet_PinnedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_fleet_pinned = /** @type {((inputs?: Station_Fleet_PinnedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Fleet_PinnedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_fleet_pinned(inputs)
});